import { AccordionItem, P1 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations';
import React from 'react';
import { Question } from '../../../data/data';
import { range } from '../../../utils';
import { EnrichedText } from '../../common/enriched-text/EnrichedText';

export type FaqQuestionProps = {
  question: Question;
};

export const FaqQuestion = ({ question }: FaqQuestionProps) => {
  const { t } = useTranslation();

  return (
    <AccordionItem
      title={t(`${question.questionPrefix}.question`)}
      key={`question-${question.questionPrefix.replace('.', '-')}`}
      id={`question-${question.questionPrefix.replace('.', '-')}`}>
      {question.paragraphs.length > 0 ? (
        question.paragraphs.map((paragraph, index) => {
          const prefix = `${question.questionPrefix}.answer.paragraph-${index + 1}`;
          return (
            <div key={`paragraph-${index}`}>
              <P1>
                <EnrichedText textKey={`${prefix}.text`} />
              </P1>
              {paragraph.numberSteps > 0 && (
                <ul>
                  {range(1, paragraph.numberSteps).map((stepNumber) => (
                    <li key={`paragraph-${index}-${stepNumber}`}>
                      <P1>
                        <EnrichedText textKey={`${prefix}.step-${stepNumber}`} />
                      </P1>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })
      ) : (
        <P1>
          <EnrichedText textKey={`${question.questionPrefix}.answer`} />
        </P1>
      )}
    </AccordionItem>
  );
};
